module.exports = __webpack_public_path__ + "assets/img/7.d243360f.png";